import { AuditAction, auditActionPrefix, getDisplayValue } from '@assess/shared/ontology-types';

import { ReasonCodeEntityClass, ReasonCodePrimaryType } from './reason-code-type.enums';
import { IReasonCodeGroupConfig, IReasonCodeType } from './reason-code-type.interfaces';

export class AuditType implements IReasonCodeType {
  readonly entityClass = ReasonCodeEntityClass.ProgramPeriod;
  readonly primaryType = ReasonCodePrimaryType.AuditActionReason;

  constructor(readonly config: IReasonCodeGroupConfig) {}
}

export const AuditNotRequiredReason = new AuditType({
  secondaryType: AuditAction.NotRequired,
  statusLabel: getDisplayValue(AuditAction.NotRequired, auditActionPrefix),
  isDefault: true,
});

export const AuditPendingReason = new AuditType({
  secondaryType: AuditAction.Pending,
  statusLabel: getDisplayValue(AuditAction.Pending, auditActionPrefix),
  isDefault: true,
});

export const AuditApprovedReason = new AuditType({
  secondaryType: AuditAction.Approved,
  statusLabel: getDisplayValue(AuditAction.Approved, auditActionPrefix),
  isDefault: true,
});

export const AuditRejectedReason = new AuditType({
  secondaryType: AuditAction.Rejected,
  statusLabel: getDisplayValue(AuditAction.Rejected, auditActionPrefix),
  isDefault: true,
});

export const AuditActionReason = [AuditNotRequiredReason, AuditPendingReason, AuditApprovedReason, AuditRejectedReason];
